<div bsModal #bsModalInstance="bs-modal" [config]="config" 
     class="modal fade" tabindex="-1" role="dialog" 
     aria-modal="true" [attr.aria-labelledby]="titleId"
     (onShow)="byShow.emit($event)"
     (onShown)="byShown.emit($event)"
     (onHide)="byHide.emit($event)"
     (onHidden)="byHidden.emit($event)">
  <div class="modal-dialog" [class]="'modal-' + size">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left" [id]="titleId">{{ title | translate }}</h4>
        @if (showClose) {
          <button type="button" class="close pull-right" aria-label="Close" (click)="hide()">
            <span aria-hidden="true">&times;</span>
          </button>
        }
      </div>
      <div class="modal-body">
        <ng-content select="jt-modal-body"></ng-content>
      </div>
      @if (hasFooter) {
        <div class="modal-footer">
          <ng-content select="jt-modal-footer"></ng-content>
        </div>
      }
    </div>
  </div>
</div>
